// v10/src/components/admin/lifespan/GlobalView.js
//
// Vista "Global" del módulo Vida límite (A6.1).
// T2: reemplaza el placeholder de T1 por la tabla GlobalAttentionTable real.
//
// Es un wrapper delgado: recibe `onSelect` desde LifespanTab para coordinar
// la navegación cuando el usuario hace click en una fila.

import React from 'react';

import GlobalAttentionTable from './GlobalAttentionTable';

const GlobalView = ({ darkMode, isActive = true, locale = 'es-AR', onSelect }) => {
  return (
    <GlobalAttentionTable
      darkMode={darkMode}
      isActive={isActive}
      locale={locale}
      onSelect={onSelect}
    />
  );
};

export default GlobalView;
